import { Box, Button, CardMedia, Typography } from "@mui/material";
import React, { useContext } from "react";
import { PreciosContext } from "../hooks/PricesContext";

const FrontCard = ({ onMoveToTopClick, isAtTop, setFront, image, symbol, description, ticker, stock }) => {
    const variacion = stock.previous_close ? ((stock.actual_price - stock.previous_close) / stock.previous_close) * 100 : 0;

    const cardStyle = {
        width: { xs: "90%", md: 300 },
        maxHeight: 470,
        boxShadow: 6,
        borderRadius: 5,
        marginLeft: { xs: "0px", sm: "10px" },
        marginRight: { xs: "0px", sm: "30px" },
        marginTop: "40px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "white"
    }
    const boxImage = {
        height: 100,
        width: { xs: "100%", sm: 280 },
        padding: 1,
        display: "flex"
    }
    const infoButton = {
        marginBottom: "20px",
        marginLeft: "20px"
    }

    return (
        <Box sx={cardStyle}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pr: 2 }}>
                <Box sx={boxImage}>
                    <CardMedia height="90%" width="80%" component="img" image={image} />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "gray" }}>Precio</Typography>
                    <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>${stock.actual_price || stock.price}</Typography>
                    <Typography sx={{ fontSize: "12px", fontWeight: "bold", color: "gray", mt: 1 }}>Variación</Typography>
                    <Typography sx={{ fontSize: "16px", fontWeight: "bold" }} style={{ color: variacion < 0 ? "red" : "#22eb17" }}>
                        {stock.previous_close ? variacion.toFixed(2) + "%" : "---"}
                    </Typography>
                </Box>
            </Box>
            <Box>
                <Button variant="contained" size="small" onClick={() => { setFront(false) }} sx={infoButton}>Informacion Financiera</Button>
            </Box>
        </Box>
    );
}

export default FrontCard;